import axios from 'axios';

const serverArquivo = axios.create({
  baseURL: process.env.REACT_APP_URL_ARQUIVOS,
});

export default serverArquivo;
